/* RESPONSIBLE TEAM: team-actions */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class ProceduresIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.tasks');
  }
}
